// extracted by mini-css-extract-plugin
module.exports = {"component":"Main_component__n9ANF"};